import React from 'react'
import { BillingContentTitle } from '../Shared/UI/Components/BillingContentTitle'

const BillingStatemets = () => {
  return <BillingContentTitle>Billing statements</BillingContentTitle>
}

export default BillingStatemets
